import { Divider } from "@braintrust/braintrust-ui-components";
import type { OfferCommon } from "@js/types/jobs";

import { InfoRow } from "./info-row";
import { OfferPreviewSectionContainter } from "./section-container";

type CommitmentDetailsProps = {
  offer: OfferCommon;
};

export const CommitmentDetails = ({ offer }: CommitmentDetailsProps) => {
  const showExtraHoursPreApproved = !!offer.pre_approve_extra_hours;
  const showAvailabilityDetails = !!offer.availability_details;
  const showSection = showExtraHoursPreApproved || showAvailabilityDetails;
  if (!showSection) {
    return <></>;
  }

  return (
    <OfferPreviewSectionContainter title="⌛  Commitment details">
      {showExtraHoursPreApproved && (
        <InfoRow label="Extra hours must be pre-approved" />
      )}
      {showExtraHoursPreApproved && showAvailabilityDetails && (
        <Divider color="beige" />
      )}
      {showAvailabilityDetails && (
        <InfoRow label={offer.availability_details} />
      )}
    </OfferPreviewSectionContainter>
  );
};
